import React from "react";
import moment from "moment";
import MaterialIcon from "../MaterialIcon";
import "./chat-pro.css";

// Bubble footer of the mobile Pro chat (ProMessageRow.ProMeta + chatGlassModel.messageStatus):
// right-aligned "edited" · HH:mm · the send status of own messages:
//   pending (not on the server yet)  done, faint
//   sent / delivered                 done, muted (delivered-but-unread stays one tick)
//   read                             done_all, info blue
//   failed                           red error button that retries

export function messageStatusOf(chat) {
  if (!chat || chat.isDeleted) return null;
  if (chat.failedToSend) return "failed";
  if (chat.messageReadByAll === true || chat.messageReadByAll === "true") return "read";
  if (chat.messageReachedToAll === true || chat.messageReachedToAll === "true") return "delivered";
  if (chat.sending || chat.uploading || (chat.local && chat.isSent === false)) return "pending";
  return "sent";
}

const TICKS = {
  read: { icon: "done_all", tone: "is-read" },
  delivered: { icon: "done", tone: "" },
  sent: { icon: "done", tone: "" },
  pending: { icon: "done", tone: "is-pending" },
};

export default function MessageMeta({ chat, showStatus = false, onRetry, labels = {}, className = "" }) {
  if (!chat) return null;
  const status = showStatus ? messageStatusOf(chat) : null;
  let tick = null;
  if (status === "failed") {
    tick = (
      <button
        type="button"
        className="kjc-meta__retry"
        onClick={(e) => {
          e.stopPropagation();
          if (onRetry) onRetry(chat);
        }}
        title={labels.retry}
        aria-label={labels.retry}
      >
        <MaterialIcon icon="error" size={16} fill={1} weight={400} />
      </button>
    );
  } else if (status) {
    const look = TICKS[status] || TICKS.sent;
    tick = (
      <span className={`kjc-meta__tick ${look.tone}`.trim()} title={labels[status]}>
        <MaterialIcon icon={look.icon} size={16} weight={400} />
      </span>
    );
  }
  return (
    <div className={`kjc-meta ${className}`.trim()}>
      {chat.isEdited && !chat.isDeleted ? <span className="kjc-meta__edited">{labels.edited}</span> : null}
      <span className="kjc-meta__time">{chat.createdAt ? moment(chat.createdAt).format("HH:mm") : ""}</span>
      {tick}
    </div>
  );
}
